import { computed, Injectable, signal } from '@angular/core';

import { CartItem, PaymentMethod, PurchaseResult } from './booking.model';

/** Decisión de TEC-301: hasta 10 boletos por compra. */
export const MAX_CART_ITEMS = 10;

/** El carrito vive en memoria: no aparta lugar, y el API revisa cupo y precio al pagar. */
@Injectable({ providedIn: 'root' })
export class BookingCart {
  readonly items = signal<readonly CartItem[]>([]);
  /** Lo que eligió el usuario; null = el primero disponible. */
  readonly chosenMethod = signal<PaymentMethod | null>(null);
  /** La última compra, para la pantalla de confirmación. */
  readonly lastPurchase = signal<PurchaseResult | null>(null);

  readonly count = computed(() => this.items().length);
  readonly total = computed(() => this.items().reduce((sum, item) => sum + item.amount, 0));
  readonly isFull = computed(() => this.count() >= MAX_CART_ITEMS);

  has(realtripId: number): boolean {
    return this.items().some((item) => item.realtripId === realtripId);
  }

  /** Falso si ya está lleno. */
  add(item: CartItem): boolean {
    if (this.has(item.realtripId)) return true;
    if (this.isFull()) return false;
    this.items.update((items) => [...items, item]);
    return true;
  }

  remove(realtripId: number): void {
    this.items.update((items) => items.filter((item) => item.realtripId !== realtripId));
  }

  /** Sin carrito: la compra es de un solo boleto. */
  replace(item: CartItem): void {
    this.items.set([item]);
  }

  finish(result: PurchaseResult): void {
    this.lastPurchase.set(result);
    this.items.set([]);
    this.chosenMethod.set(null);
  }

  /** Al cerrar sesión: lo de esta persona no debe quedar para la siguiente. */
  clear(): void {
    this.items.set([]);
    this.chosenMethod.set(null);
    this.lastPurchase.set(null);
  }
}
